export const TAB_ORDERS = {
	NONE: 'none',
	ALL: 'all',
	WITHOUT_PAYMENT: 'without-payment',
	CREATED: 'created',
	PAID: 'paid',
	REALIZED: 'realized',
	INVOICED: 'invoiced',
	CLEARED: 'cleared',
	FINAL_ORDER: 'final-order',
	GROUP: 'group',
	ARCHIVE: 'archive',
	FOR_INVOICING: 'for-invoicing',
	NETWORK_PROCESSING: 'network-processing',
};

export const STATUS_ORDERS = {
	CREATED: 0,
	GENERATED_TRANSFER: 1,
	REALIZED: 2,
	INVOICED: 3,
	CLEARED: 4,
	CANCELED: 5,
	ARCHIVE: 6,
};

export const TYPES_ORDERS = {
	SINGLE: 1,	// "Pojedyncze"
	GROUP: 2, 	// "Grupowe"
	FINAL: 3, 	// "Końcowe"
};
